
document.addEventListener('DOMContentLoaded', function() {
    // Navigation toggle
    const navTrigger = document.querySelector('#res-nav-icon');
    const nav = document.querySelector('.menu-primary-menu-container');
    navTrigger.addEventListener('click', () => {
        navTrigger.querySelector('#hamburger-icon').classList.toggle('show');
        navTrigger.querySelector('#close-icon').classList.toggle('hide');
        navTrigger.querySelector('#hamburger-icon').classList.toggle('hide');
        navTrigger.querySelector('#close-icon').classList.toggle('show');
        nav.classList.toggle('show');
    })
    
});